import { CursorContextProvider, Cursor } from "../components/general/Cursor";
import Nav from "../components/general/Nav";
import Hero from "../components/supportus/Hero";
import Intro from "../components/supportus/Intro";
import SupportUs from "../components/supportus/SupportUs";
// import DemoCountdown from "../components/countdown/DemoCountdown";
import styled from "styled-components";

const Container = styled.div`
  @media only screen and (max-width: 768px) {
  }
`;

function Support() {
  return (
    <CursorContextProvider>
      <Cursor />
      {/* <DemoCountdown /> */}
      <Hero />
      <Container>
        <Intro />
        <SupportUs />
      </Container>
      <Nav color={0} home={1} />
    </CursorContextProvider>
  );
}

export default Support;
